/**
 * Client-side seller submission conversion eligibility (M12).
 * Mirrors server rules for UI hints; server remains source of truth.
 */

export const SELLER_CONVERSION_BLOCK_MESSAGES_ES = Object.freeze({
  already_converted: "Esta solicitud ya fue convertida.",
  archived: "No se puede convertir una solicitud archivada.",
  spam: "No se puede convertir una solicitud marcada como spam.",
  not_approved: "Aprueba la solicitud antes de convertirla.",
  not_ready: "La solicitud debe estar lista para publicación.",
  consent_required: "Falta consentimiento del vendedor.",
  missing_required_fields: "Faltan datos obligatorios del vehículo.",
});

/**
 * @param {object|null|undefined} submission
 */
export function getSellerSubmissionConversionEligibility(submission) {
  if (!submission) return { ok: false, reason: "not_found" };
  if (submission.admin?.convertedListingId || submission.convertedListingId) {
    return { ok: false, reason: "already_converted" };
  }
  if (submission.reviewStatus === "archived" || submission.admin?.archivedAt) {
    return { ok: false, reason: "archived" };
  }
  if (submission.reviewStatus === "spam") {
    return { ok: false, reason: "spam" };
  }
  if (submission.reviewStatus !== "approved") {
    return { ok: false, reason: "not_approved" };
  }
  if (submission.workflowStatus !== "ready_for_listing") {
    return { ok: false, reason: "not_ready" };
  }
  if (!submission.consent?.consentAccepted) {
    return { ok: false, reason: "consent_required" };
  }

  const vehicle = submission.vehicle || {};
  const pricing = submission.pricing || {};
  const seller = submission.seller || {};
  const required = [
    vehicle.make,
    vehicle.model,
    vehicle.year,
    vehicle.mileageKm,
    pricing.askingPrice,
    seller.city,
  ];
  if (required.some((value) => value == null || value === "")) {
    return { ok: false, reason: "missing_required_fields" };
  }

  return { ok: true };
}

export function sellerConversionBlockMessage(reason) {
  return SELLER_CONVERSION_BLOCK_MESSAGES_ES[reason] || "No se puede convertir esta solicitud.";
}
